
import type { Dictionary, RegularFilter, RegularFilterSelectedValues } from '../../models'
import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'

import { defineComponent } from 'vue'

import { mapActions } from 'vuex'

import { EpbKeywords } from '../../components/shared/epb-keywords'
import ToolingFormLayout from '../../components/tooling/tooling-form-layout.component.vue'

import { FeatureIdEnum } from '../../enums/feature-id.enum'

import { CrudFormMixin } from '../../mixins/crud-form.mixin'

import { ROUTER_CONSTS } from '../../router/router.consts'
import { CRUD_CONSTS } from '../../store/crud/crud.consts'

export default defineComponent({
  name: 'BlacklistForm',
  components: {
    EpbKeywords,
    ToolingFormLayout,
  },
  mixins: [CrudFormMixin],
  data() {
    return {
      dataType: ActionTypeEnum.BLACKLIST,
      updateMode: this.$route.name === ROUTER_CONSTS.routes[FeatureIdEnum.BLACKLIST].update,
      item: {
        id: undefined,
        terms: [],
        filters: {
          lang: undefined,
        },
        enabled: true,
      },
      messages: this.$epb.messages.tools.blacklist,
      existingEnabledBlacklist: false,
    }
  },
  computed: {
    filters(): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)()
      filters.lang.config = {
        ...filters.lang.config,
        mandatory: true,
        multiselectDisabled: true,
      }
      return filters
    },
    formIsValid(): boolean {
      if (!this.item.filters?.lang?.length) {
        return false
      }
      if (!this.item.terms.length) {
        return false
      }
      return true
    },
  },
  methods: {
    ...mapActions(CRUD_CONSTS.moduleName, {
      fetchData: CRUD_CONSTS.actions.fetchData,
    }),
    async onFilterChange(filter: RegularFilter, selectedValues: RegularFilterSelectedValues) {
      CrudFormMixin.methods.onFilterChange.bind(this)(filter, selectedValues)
      await this.checkExistingEnabledBlacklist()
    },
    async checkExistingEnabledBlacklist() {
      const blacklistsByLanguage = await this.fetchData({
        dataType: this.dataType,
        filters: this.filters,
      })
      this.existingEnabledBlacklist = !!blacklistsByLanguage.data.items.find(
        blacklist => blacklist.enabled && blacklist.id !== this.item.id,
      )
      if (this.existingEnabledBlacklist && this.item.enabled) {
        this.item.enabled = !this.item.enabled
      }
    },
  },
  watch: {
    'item.filters.lang': async function () {
      this.$emit('updateLoading', { visible: true })
      try {
        await this.checkExistingEnabledBlacklist()
        this.$emit('updateLoading', { visible: false })
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error))
        this.$emit('updateLoading', { visible: false })
      }
    },
  },
})
